// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Bulk Operations Area
export class AreaBulkOperations {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Bulk Operations
    /** Import tokens in bulk using new import routine
     *
     * @param designSystemId - Remote design system to write to
     * @param brandId - Remote brand to write to
     * @param sourceName - Name of the source, such as Figma file name
     * @param sourceId - Unique ID of the source, such as Figma file id
     * @param sourceType - Source from which import originates. Currently only "FigmaVariablesPlugin" is supported
     * @param payload - Payload to import. Types to come
     * @param isTokenTypeSplitEnabled - should we split tokens by type into separate collections.
     * @param version - should we use new import routine with extended collections support. Should be set to "2" in production.
     * @returns Nothing
     */
    async importTokens(designSystemId, brandId, sourceId, sourceName, sourceType, payload, isTokenTypeSplitEnabled, version = "2") {
        return this.dataCore.importTokens(designSystemId, brandId, sourceId, sourceName, sourceType, payload, isTokenTypeSplitEnabled, version);
    }
    /** Batch updates, creates or deletes token data from Supernova at once. Use this method to perform multiple operations at once instead of chaining single update operations. Batch routine runs everything in a single transaction, so either all operations succeed or all fail.
     *
     * WARNING: This method is not yet complete and only supports limited set of operations. Also, doesn't work as transation just yet.
     * @param to - Remote version to write to
     * @param data - Update information. All keys except token and its parent are optional and any combination of optional properties is allowed.
     * @returns Nothing
     */
    async updateTokenData(to, data) {
        await this.dataCore.bulkUpdateTokenData(to.designSystemId, to.versionId, data);
    }
    /** Batch updates element properties into Supernova at once. Use this method to perform bulk change instead of chaining single update operations. Batch routine runs everything in a single transaction, so either all updates succeed or all fail.
     *
     * @param to - Remote version to write to
     * @param data - Update information. All keys except component and its parent are optional and any combination of optional properties is allowed.
     * @returns Nothing
     */
    /** Bulk update properties */
    async updateElementProperties(to, data) {
        return this.dataCore.updateElementProperties(to.designSystemId, to.versionId, {
            type: "ElementPropertyValuesEdit",
            values: data,
        });
    }
    /** Batch updates, creates or deletes component data from Supernova at once. Use this method to perform multiple operations at once instead of chaining single update operations. Batch routine runs everything in a single transaction, so either all operations succeed or all fail.
     *
     * WARNING: This method is not yet complete and only supports limited set of operations. Also, doesn't work as transation just yet.
     * @param to - Remote version to write to
     * @param data - Update information. All keys except component and its parent are optional and any combination of optional properties is allowed.
     * @returns Nothing
     */
    async updateComponentData(to, data) {
        return this.dataCore.bulkUpdateComponentData(to.designSystemId, to.versionId, data);
    }
    /** Fetches a chain of workspace, design system, version and brand, available to the current user.
     * @param preferredWorkspaceId - Preferred workspace ID to fetch
     * @param preferredDesignSystemId - Preferred design system ID to fetch
     * @param preferredVersionId - Preferred version ID to fetch
     * @param preferredBrandId - Preferred brand ID to fetch
     */
    async bootstrapData(preferredWorkspaceId, preferredDesignSystemId, preferredVersionId, preferredBrandId) {
        return this.dataCore.bootstrapData(preferredWorkspaceId, preferredDesignSystemId, preferredVersionId, preferredBrandId);
    }
}
